module.exports = __webpack_public_path__ + "img/__icon_BUS_EKSPRES.011c6047.svg";